import Echo from "laravel-echo";
import Pusher from "pusher-js";
import Cookies from "js-cookie";
(window as any).Pusher = Pusher;
import RoleApi from "@/API/Role/Role";
import Auth from "@/API/Auth";

declare const APP_NAME: string;
declare const NOTIFICATION_REVERB_HOST: string;
declare const NOTIFICATION_REVERB_PORT: number;
declare const NOTIFICATION_REVERB_KEY: string;
declare const NOTIFICATION_REVERB_AUTH_ENDPOINT: string;

const roleApi = new RoleApi();

// Get bearer token from cookies
const getBearerToken = (): string => {
  let bearerToken = "";
  let i = 0;
  while (Cookies.get(`${APP_NAME}_api_token_part${i + 1}`)) {
    let cookiePart = Cookies.get(`${APP_NAME}_api_token_part${i + 1}`);
    bearerToken += cookiePart;
    i++;
  }
  return bearerToken;
};

// Store echo instance
let echo: any = null;
let echoInitialized = false;

// Function to initialize echo after authentication
export const initializeEcho = async (): Promise<Echo<any>> => {
  if (echoInitialized && echo) {
    return echo;
  }

  // console.log("Initializing Echo with Auth.USER:", Auth.USER);

  // Wait for Auth.USER to be populated
  if (!Auth.USER?.job_id || !Auth.USER?.department_id) {
    console.warn("Auth.USER not fully loaded, cannot initialize Echo");
    throw new Error("Auth.USER not fully loaded");
  }

  // Fetch role with authenticated user data
  const role: any = await roleApi.getRoleJobWithDepartment(
    Auth.USER.job_id,
    Auth.USER.department_id,
  );

  const bearerToken = getBearerToken();

  echo = new Echo({
    broadcaster: "reverb",
    key: NOTIFICATION_REVERB_KEY,
    wsHost: NOTIFICATION_REVERB_HOST,
    wsPort: NOTIFICATION_REVERB_PORT,
    forceTLS: false,
    enabledTransports: ["ws", "wss"],
    authEndpoint: NOTIFICATION_REVERB_AUTH_ENDPOINT,
    auth: {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        Accept: "application/json",
      },
      params: {
        role_id: role.id,
        team_ids: Auth.USER?.team_ids?.map((id: string) => String(id)) || [],
      },
    },
  });

  echoInitialized = true;
  return echo;
};

// Export getter function for echo instance
export const getEcho = (): Echo<any> | null => {
  return echo;
};

// Export default as echo or initialization wrapper for backwards compatibility
export default {
  initializeEcho,
  getEcho,
};
